module.exports = __webpack_public_path__ + "static/media/Waves.c83902ba.webp";